<avi-state-page class="cportal-page clr-wrapper">
    <avi-state-page_main-content>
        <div class="cportal-page__header-container">
            <div class="cportal-page__status-icon-and-text">
                <avi-tooltip-icon-with-content-wrapper
                    shape="circle"
                    size="28"
                    status="{{ aviCloudConnectedStatus }}"
                    [solid]="true"
                    [hidden]="busy"
                    class="cportal-page__pulse-status"
                >
                    {{ portalUrl$ | async }}
                </avi-tooltip-icon-with-content-wrapper>
                <div
                    class="cportal-page__pulse-spinner"
                    *ngIf="busy"
                >
                    <clr-spinner [clrMedium]="true"></clr-spinner>
                </div>
                <h2 class="cportal-page__pulse-header">
                    {{ l10nKeys.cloudServicesLabel | vtranslate }}
                </h2>
            </div>
            <cds-button
                action="flat"
                (click)="openRegistrationModal(true)"
                [disabled]="busy || !isAdminTenant"
                title="{{ l10nKeys.editCloudServicesSettingsTooltip | vtranslate }}"
            >
                {{ globalL10nKeys.editLabel | vtranslate }}
            </cds-button>
            <cds-button
                action="flat"
                (click)="reconnectController()"
                [disabled]="!isAdminTenant"
                *ngIf="isControllerRegistered"
                title="{{ l10nKeys.reconnectLabel | vtranslate }}"
            >
                {{ l10nKeys.reconnectLabel | vtranslate }}
            </cds-button>
        </div>
        <div
            *ngIf="connectivityAndRegisteredMessage"
            class="cportal-page__alert"
        >
            <avi-alert-group alertType="{{ hasConnectivityError ? AlertType.danger : AlertType.info }}">
                {{ connectivityAndRegisteredMessage }}
                <cds-alert-actions>
                    <cds-button
                        (keydown.enter)="openRegistrationModal()"
                        (click)="openRegistrationModal()"
                        *ngIf="!hasConnectivityError && isUnregisteredAndConnected && !busy"
                    >
                        {{ l10nKeys.controllerRegisteredControllerBtnLabel | vtranslate }}
                    </cds-button>
                    <cds-button
                        (keydown.enter)="reconnectController()"
                        (click)="reconnectController()"
                        *ngIf="reconnectNowVisible"
                    >
                        {{ l10nKeys.reconnectNowLabel | vtranslate }}
                    </cds-button>
                </cds-alert-actions>
            </avi-alert-group>
        </div>

        <div class="cportal-page__avi-dashboard-widgets-container">
            <avi-dashboard-widgets [widgetConfigs]="widgetConfigs | permittedWidgets"></avi-dashboard-widgets>
        </div>
    </avi-state-page_main-content>
</avi-state-page>
